import { PAYMENT_STATUS } from "pages/AccountSettlementHistoryOrderId/constants/PaymentStatus";
import { useMemo, useState } from "react";
import { useSelector } from "store";
import { scrollTop } from "utility";
import { getPaymentType } from "utility/getPaymentType";

import { createReceiptData } from "../../utils/createReceiptData";

import type { OrderData } from "../../types/OrderData";
import type { ProductItem } from "../../types/ProductItem";
import type { ReceiptData } from "containers/account/receipt/AccountReceipt";

type UseReceiptStateInput = {
  orderData: OrderData | null;
  orderList: ProductItem[];
};

type UseReceiptStateOutput = {
  isDisplayReceipt: boolean;
  receiptData: ReceiptData;
  handleShowReceipt: () => void;
  handleCloseReceipt: () => void;
};

export const useReceiptState = (
  input: UseReceiptStateInput
): UseReceiptStateOutput => {
  const { orderData, orderList } = input;
  const user = useSelector((state) => state.auth.user);
  const [isDisplayReceipt, setIsDisplayReceipt] = useState(false);

  const receiptData = useMemo(() => {
    return createReceiptData({
      orderData: orderData ?? {
        orderId: 0,
        purchasedAt: "",
        purchasedCount: 0,
        purchasedType: getPaymentType(null),
        paymentStatus: PAYMENT_STATUS.UNPROCESS,
        totalPrice: 0,
        shippingFee: 0,
        serviceFee: 0,
        settlementFee: 0,
      },
      orderList,
      userId: user.uid,
      userName: user.displayName ?? "",
    });
  }, [orderData, orderList, user.uid, user.displayName]);

  const handleShowReceipt = () => {
    setIsDisplayReceipt(true);
    scrollTop();
  };

  const handleCloseReceipt = () => {
    setIsDisplayReceipt(false);
    scrollTop();
  };

  return {
    isDisplayReceipt,
    receiptData,
    handleShowReceipt,
    handleCloseReceipt,
  };
};
